<template>
  <v-form class="pt-2" ref="form">
    <AutocompleteGrade
      v-model="grade"
      label="Học phần"
      required
      dense
      outlined
      class="required my-4"
      :rules="[$rules.required]"
      @change="gradeChanged"
    />
    <v-row>
      <v-col cols="12" md="6">
        <AutocompleteDivision
          v-model="division"
          label="Chương trình đào tạo"
          required
          dense
          outlined
          class="required"
          :rules="[$rules.required]"
          :filter="divisionFilter"
        />
      </v-col>
      <v-col cols="12" md="6">
        <AutocompleteDepartment
          v-model="department"
          label="Cơ sở"
          required
          dense
          outlined
          class="required"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-if="totalDate !== null"
          v-model="totalDate"
          label="Tổng số buổi học"
          outlined
          required
          dense
          disabled
        />
      </v-col>
      <v-col cols="12" md="6">
        <DateIOSPicker
          :date.sync="beginningDate"
          label="Ngày bắt đầu"
          dense
          outlined
          class="required"
          :rules="[$rules.required, $rules.date]"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          ref="title"
          v-model="className"
          label="Tên lớp"
          placeholder="Nhập tên lớp"
          outlined
          class="required"
          :rules="[$rules.required]"
          dense
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-select
          v-model="classMode"
          :items="classModeOptions"
          label="Hình thức học"
          required
          dense
          outlined
          class="required"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-textarea ref="description" v-model="description" label="Ghi chú" outlined rows="3" auto-grow dense />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import get from 'lodash-es/get'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision'
import AutocompleteDepartment from '@/components/basic/input/AutocompleteDepartment'
import DateIOSPicker from '../picker/DateIOSPicker.vue'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteDivision,
    AutocompleteDepartment,
    DateIOSPicker,
  },
  props: {
    classData: {
      type: [Object],
      required: true,
      default: () => {},
    },
    gradeData: Object,
    courseData: Object,
  },
  data: () => ({
    valid: true,
    course: '',
    grade: '',
    division: '',
    department: '',
    startTime: '',
    endTime: '',
    title: '',
    description: '',
    teachers: [],
    mentors: [],
    staff: {},
    className: '',
    totalDate: null,
    beginningDate: null,
    classMode: 'offline',
    classModeOptions: [
      { text: 'Trực tiếp (offline)', value: 'offline' },
      { text: 'Trực tuyến (online)', value: 'online' },
      { text: 'Kết hợp (hybrid)', value: 'hybrid' },
    ],
  }),
  computed: {
    getCourseItems() {
      return this.grade ? this.grade.courses : []
    },
    divisionFilter() {
      return { academicLevel: get(this.grade, 'academicLevel.id') }
    },
  },
  methods: {
    gradeChanged(grade) {
      if (get(this.grade, 'academicLevel.id') !== get(grade, 'academicLevel.id')) {
        this.division = null
      }
      this.grade = grade
    },
    getCourseFilter() {
      return { grade: get(this.grade, 'id', null) }
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetDefault() {
      if (this.classData) {
        this.teachers = this.classData.teachers
        this.mentors = this.classData.mentors
        this.code = this.classData.code
        this.title = this.classData.title
        this.grade = this.classData.grade
        this.className = this.title
        this.course = this.courseData || this.classData.course
        this.division = this.classData.division
        this.department = this.classData.department
        this.startTime = this.classData.startTime
        this.description = this.classData.description
        this.endTime = this.classData.endTime
        this.staff = get(this.classData, 'staff.id', null)
        this.totalDate = get(this.classData, 'grade.totalDate', null)
        this.beginningDate = get(this.classData, 'beginningDate', null)
        this.classMode = get(this.classData, 'metadata.classMode', 'offline')
      } else {
        this.teachers = []
        this.mentors = []
        this.code = ''
        this.title = ''
        this.course = null
        this.grade = null
        this.division = null
        this.department = null
        this.startTime = ''
        this.description = ''
        this.endTime = ''
        this.staff = ''
        this.beginningDate = null
        this.classMode = 'offline'
      }
    },
    getData() {
      return {
        teachers: this.teachers,
        description: this.description,
        grade: get(this.grade, 'id'),
        division: get(this.division, 'id'),
        department: this.department,
        code: this.code,
        title: this.className.trim(),
        mentors: this.mentors,
        metadata: {
          classMode: this.classMode
        }
      }
    },
  },
  created() {
    this.resetDefault()
  },
  watch: {
    classData() {
      this.resetDefault()
    },
  },
}
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__selections {
  margin-bottom: 0;
}
</style>
